module.exports = __webpack_public_path__ + "media/img/corporate/mask-79797cef09ffb891bb354e568c94148e.svg";